export async function lazyLoadedVideoController(videoElement) {
    const { default: HlsModule } = await import('hls.js');
    const hls = new HlsModule();
    hls.config.abrEwmaDefaultEstimate = 40000;
    hls.config.startLevel = 2;
    hls.config.maxStarvationDelay = 2;
    hls.config.maxLoadingDelay = 2;
    hls.loadSource(videoElement.dataset.hls || '');
    hls.attachMedia(videoElement);
    // videoElement.dataset.hlsInstance = hls;
}
